import React from 'react'
import { bindActionCreators } from 'redux'
import './homenav.scss';
import { logout } from '../../modules/admin';
import { connect } from 'react-redux'

const logoutText = 'Log out';

class Homenav extends React.Component {

  render() {
    return (
      <div className="navWrapper">
        <div className="navEmail">{this.props.admin.email}</div>
        <div className="navLogout" onClick={this.props.logout}>{logoutText}</div>
      </div>
    )
  }
}


const mapStateToProps = ({ admin }) => ({
  admin: admin.user,
  adminObj: admin
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({logout}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Homenav)
